<template>
  <div>
    <h1 class="page-header">Counter Profile</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Food Court <span class="text-danger">*</span></label>
              <select
                v-model="model.foodcourt_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('foodcourt_id') }"
              >
                <option value="">--select--</option>
                <option v-for="(foodCourt, index) in foodCourts" :key="index" :value="foodCourt.foodcourt_id">{{
                  foodCourt.name_en
                }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('foodcourt_id')">
                {{ errors.first('foodcourt_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Name KH</label>
              <input
                v-model="model.name_kh"
                class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('name_kh') }"
                placeholder="Enter name KH"
              />
              <div class="invalid-feedback" v-if="errors.has('name_kh')">
                {{ errors.first('name_kh') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Name EN <span class="text-danger">*</span></label>
              <input
                v-model="model.name_en"
                class="form-control"
                :class="{ 'is-invalid': errors.has('name_en') }"
                placeholder="Enter name EN"
              />
              <div class="invalid-feedback" v-if="errors.has('name_en')">
                {{ errors.first('name_en') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="btn btn-default mr-2" @click.prevent="cancel">
                Cancel
              </ts-button>
              <ts-button v-if="updating" class="btn btn-primary" :waiting="waiting" @click.prevent="update">
                Update
              </ts-button>
              <ts-button v-if="!updating" class="btn btn-primary" :waiting="waiting" @click.prevent="store">
                Save
              </ts-button>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetchData" @fetched="fetchData = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DataTable from './table.vue'
export default {
  name: 'counter-profile-form',
  components: { DataTable },
  data() {
    return {
      model: {
        counter_id: '',
        foodcourt_id: '',
        name_kh: '',
        name_en: ''
      },
      errors: new Errors(),
      updating: false,
      waiting: false,
      fetchData: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('inventory/counterProfile', ['foodCourts', 'edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('inventory/counterProfile/store', Object.assign({}, this.model))
        .then(response => {
          this.fetchData = true
          this.waiting = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('inventory/counterProfile/update', Object.assign({}, this.model))
        .then(response => {
          this.fetchData = true
          this.waiting = false
          this.$toasted.success(response.message)
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    cancel() {
      this.fetchData = true
      this.updating = false
      this.$store.commit('inventory/counterProfile/SET_EDIT_DATA', {})
      this.$router.push({ name: 'counter-profile' })
      this.clearInput()
    },

    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.updating = true
        this.model.counter_id = this.edit_data.counter_id
        this.model.foodcourt_id = this.edit_data.foodcourt_id
        this.model.name_kh = this.edit_data.name_kh
        this.model.name_en = this.edit_data.name_en
      }
    },
    clearInput() {
      this.model.counter_id = ''
      this.model.foodcourt_id = ''
      this.model.name_kh = ''
      this.model.name_en = ''
    },
    clickBackURL() {
      this.$store.commit('counterProfile/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetchData = true
      this.updating = false
    }
  },
  watch: {
    edit_data: {
      handler() {
        if (!_.isEmpty(this.edit_data)) {
          this.setEditData()
        }
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('counterProfile/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
